export const MM_PER_INCH = 25.4;

export const fractionLigatures = {
  '': '', // not a real ligature, used for conversion (implicit round down)
  '1/8': ' ⅛',
  '1/4': ' ¼',
  '3/8': ' ⅜',
  '1/2': ' ½',
  '5/8': ' ⅝',
  '3/4': ' ¾',
  '7/8': ' ⅞',
  'round up!': 'round up!', // not a real ligature, used for conversion
};

export function metricToImperial(mm) {
  const out = {
    feet: '0',
    inches: '0',
    onlyInches: '0',
  };

  let i_wholeInches = (mm / MM_PER_INCH) << 0;
  let m_inchRest = mm - i_wholeInches * MM_PER_INCH;

  let i_inchRestAsFraction =
    Object.values(fractionLigatures)[
      Math.round((m_inchRest / MM_PER_INCH) * 8)
    ];

  if (i_inchRestAsFraction === 'round up!') {
    m_inchRest = 0; // discard since we rounded up
    i_inchRestAsFraction = '';
    i_wholeInches++;
  }

  const i_feet = (i_wholeInches / 12) << 0;
  const i_feetRest = i_wholeInches % 12;

  out.feet = '' + i_feet;
  out.inches = '' + i_feetRest + i_inchRestAsFraction;
  out.onlyInches = '' + i_wholeInches + i_inchRestAsFraction;

  return out;
}

export function withLigatures(inches) {
  return inches.replace(/\d+\/\d+/g, fraction => fractionLigatures[fraction]);
}

export function asMm(values) {
  if (values.imp) {
    return MM_PER_INCH * (12 * values.major + 1 * values.minor);
  }
  return 10 * values.minor;
}

export const mm = {
  toCm: val => val / 10,
  toDm: val => val / 100,
  toM: val => val / 1000,
  toInches: val => Math.round(val * 0.0393700787),
};

export const cm = {
  toMm: val => val * 10,
  toDm: val => val / 10,
  toM: val => val / 100,
  toInches: val => Math.round(val * 0.393700787),
};

export const dm = {
  toMm: val => val * 100,
  toCm: val => val * 10,
  toM: val => val / 10,
  toInches: val => Math.round(val * 3.93700787),
};

export const m = {
  toMm: val => val * 1000,
  toCm: val => val * 100,
  toDm: val => val * 10,
  toInches: val => Math.round(val * 39.3700787),
};

export const inches = {
  toMm: val => Math.round(val * 25.4),
  toCm: val => Math.round(val * 2.54),
  toDm: val => Math.round(val * 0.254),
  toM: val => Math.round(val * 0.0254),
};
